import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';

export const CTAWrapper = styled.div<{ expanded?: boolean }>`
  // margin-bottom: ${({ expanded }) => expanded && '44px'};
  margin-top: 24px;
`;

export const ShowAllButton = styled.button`
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  border: none;
  border-bottom: 1px solid ${COLORS.grey60};
  padding-bottom: 2px;
  cursor: pointer;
  background-color: transparent;
`;

export const ModelFamilyStyleFrame = styled(animated.div)`
  padding: 24px;
`;

export const AllModelsWrapper = styled.div<{ expanded?: boolean; contentHeight?: string }>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow: hidden;
  transition:
    max-height 1s ease,
    opacity 0.5s ease,
    margin-top 1.5s ease;
  margin-top: ${({ expanded }) => (expanded ? '44px' : '0')};
  opacity: ${({ expanded }) => (expanded ? `1` : '0')};
  max-height: ${({ expanded, contentHeight }) => (expanded && contentHeight ? contentHeight : '0')};
`;

export const Legend = styled.div`
  margin-bottom: 12px;
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const CommonModelsTitle = styled.div`
  margin-bottom: 12px;
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const GroupModelsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns, each taking 50% of the width */
  row-gap: 24px;
`;

export const CommonModelsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* Two columns, each taking 50% of the width */
  row-gap: 24px;
`;

export const ActiveOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  cursor: pointer;
`;

export const ActiveListWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const CancellButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
`;
